
TechsController.$inject = ["$http"];angular
  .module('app', ['ui.router', 'ngAnimate', 'ui.bootstrap', 'pascalprecht.translate', 'ngSanitize'])
  .config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: 'app/i18n/',
      suffix: '.json'
    });

    var default_lang = "es";

    $translateProvider.preferredLanguage('es');
  }]);

angular
  .module('app')
  .component('fountainTechs', {
    templateUrl: 'app/techs/techs.html',
    controller: TechsController
  });

/** @ngInject */
function TechsController($http) {
  var vm = this;

  $http
    .get('app/techs/techs.json')
    .then(function (response) {
      vm.techs = response.data;
    });
}

angular
  .module('app')
  .component('fountainTech', {
    templateUrl: 'app/techs/tech.html',
    bindings: {
      tech: '<'
    }
  });

angular
  .module("app")
  .component("appStep3", {
    templateUrl: "app/templates/step3.html",
    controller: ["$scope", "CategoryFactory", "$uibModal", "formValueFactory", '$window', "$http", "$translate", function ($scope, CategoryFactory, $uibModal, formValueFactory, $window, $http, $translate) {
      var appStep3 = this;
      this.categories = CategoryFactory.getAll();
      this.values = formValueFactory;
      this.percentage_by_category = 100;

      for (var i in this.categories) {
        this.values["category"] = this.categories[i];
        break;
      }

      this.closeModal = function () {
        modalInstance.close();
      };

      this.totalperHour = function () {
        var monthlySalary = this.getAdjustedMonthlySalary();
        var monthlyBillableHours = this.getMonthlyBillableHoursTotal();
        if (null != monthlySalary && null != monthlyBillableHours) {
          return parseFloat(monthlySalary / monthlyBillableHours).toFixed(2);
        }
      };
      this.getMonthlyBillableHoursTotal = function () {
        var value = formValueFactory.getBillableYearHoursTotal();
        if (value != null) {
          return Math.floor(value / 12);
        }
      },
        this.getAdjustedMonthlySalary = function () {
          return formValueFactory.getAdjustedMonthlySalary()
        };
      this.getPercentageOfValue = function (value) {

      };


      this.buildPercentages = function () {
        var category = this.values.category;
        var totalAmount = this.totalperHour();
        var category_max_amount = 0;
        if (null != category && null != totalAmount) {
          for (var i in category.amounts) {
            if (category.amounts[i][formValueFactory.step1.currency.code] > category_max_amount) {
              category_max_amount = category.amounts[i][formValueFactory.step1.currency.code];
            }
          }
          if (totalAmount > category_max_amount) {
            category_max_amount = totalAmount;
          }
          category.percentages = {};
          for (var i in category.amounts) {
            category.percentages[i] = pencentage(category.amounts[i][formValueFactory.step1.currency.code], category_max_amount);
          }
          this.percentage_by_category = pencentage(totalAmount, category_max_amount)
        }
      };

      this.categoryAmount = function (plan) {
        return this.values.category.amounts[plan][this.formValueFactory.step1.currency.code];
      };
      this.mailto_url = "";

      $translate("MAILTO_SUBJECT").then(function (subject) {
        console.log(subject);
        $translate("MAILTO_BODY").then(function (mail_body) {
          console.log(mail_body);

          appStep3.mailto_url = "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(mail_body);
        }, function () { });
      }, function () { });


      this.mailto = function () {
        var body = "Hola,\n" +
          "Entra a www.calculadorafreela.com  y podrás saber (gratis) cuánto cobrar tu hora como freelancer. ";
        return "mailto:?subject=" + encodeURIComponent("Con esta web podrás saber cuánto cobrar como freelancer!") + "&body=" + encodeURIComponent(body);
      };

      this.sharePopup = function (type) {
        var url = null;
        if ("twitter" == type) {
          $translate("TWITTER_POST").then(function (text) {
            text = encodeURIComponent(text);
            url = "https://twitter.com/intent/tweet?text=" + text;
            $window.open(url, "", "width=670,height=462,top=100,left=100");
          }, function (translationId) {
            text = encodeURIComponent(translationId);
            url = "https://twitter.com/intent/tweet?text=" + text;
            $window.open(url, "", "width=670,height=462,top=100,left=100");
          });


        } else if ('facebook' == type) {
          fbShare("https://www.calculadorafreela.com/", "", "", "", 670, 0);
        }

      };

      function fbShare(url, title, descr, image, winWidth, winHeight) {
        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);
        window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
      }

      function pencentage(amount, _100) {
        return amount * 100 / _100
      }

      $scope.$on("selectStep3", function () {
        //$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

        var values = {
          currency: formValueFactory.step1.currency.code,
          current_salary: formValueFactory.step1.currentSalary,
          office: formValueFactory.step1.office,
          internet: formValueFactory.step1.internet,
          software: formValueFactory.step1.software,
          phone: formValueFactory.step1.phone,
          new_laptop: formValueFactory.step1.newLaptop,
          marketing: formValueFactory.step1.marketing,
          insurance: formValueFactory.step1.insurance,
          accountant: formValueFactory.step1.accountant,
          health_insurance: formValueFactory.step1.healthInsurance,
          taxes: formValueFactory.step1.taxes,
          others: formValueFactory.step1.others,

          yearly_billable_hours: formValueFactory.step2.yearlyBillableHours,
          sick_days: formValueFactory.step2.sickDays,
          business_days_of_vacation: formValueFactory.step2.businessDaysOfVacation,
          nonbillable_hours_percentage: formValueFactory.step2.nonbillableHoursPercentage,
          holidays: formValueFactory.step2.holidays,
          monthly_billable_hours: appStep3.getMonthlyBillableHoursTotal(),
          hour_value: appStep3.totalperHour()

        };

        $http({
          method: "post",
          data: values,
          url: "/calculate-hour",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
          },
          transformRequest: function (data, headers) {
            console.log(data);;
            return jQuery.param(data);
          }
        }).success(function (http, data) {
          console.log(http);
          console.log(data);
        });

        $window.setTimeout(function () {
          appStep3.showFinalModal();
        }, 15000);

      });

      this.showFinalModal = function () {
        var modalInstance = $uibModal.open({
          animation: $scope.animationsEnabled,
          templateUrl: 'app/templates/step3Modal.html',
          //windowTemplateUrl: "app/templates/step3ModalWindow.html",
          openedClass: "modal-open modal-workana",
          controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };
          }],
          size: "lg",
          controllerAs: "modalCtl"
        });
      };


    }],
    controllerAs: "appStep3"
  });

angular
  .module("app")
  .component("appStep2", {
    templateUrl: "app/templates/step2.html",
    controller: ["$scope", "formValueFactory", function ($scope, formValueFactory) {
      this.nextStep = nextStep;
      this.values = formValueFactory.step2;
      function nextStep() {
        this.form2.$setSubmitted();
        if (this.form2.$valid) {
          $scope.$emit("nextStep");
          formValueFactory.frelancerCost();
        }
      }
    }],
    controllerAs: "appStep2"
  });

angular
  .module("app")
  .component("appStep1", {
    templateUrl: "app/templates/step1.html",
    controller: ['CurrencyFactory', 'formValueFactory', '$scope', "$timeout", "appConfig", function (CurrencyFactory, formValueFactory, $scope, $timeout, appConfig) {

      this.activeTab = 0;
      this.currencies = CurrencyFactory.getAll();
      this.nextStep = nextStep;
      this.prevStep = prevStep;
      this.values = formValueFactory.step1;

      for (var i in this.currencies) {
        if (appConfig.default_currency == this.currencies[i].code) {
          this.values["currency"] = this.currencies[i];
          break;
        }
      }
      function nextStep() {
        switch (this.activeTab) {
          case 0:
            // validar el primer formulario

            this.form1_1.$setSubmitted();
            if (!this.form1_1.$valid) {
              return;
            }
            break;
          case 1:
            // validar el segundo formulario

            this.form1_2.$setSubmitted();
            if (!this.form1_2.$valid) {
              return;
            }
            break;
          case 2:
            // validar el tercer formulario
            this.form1_3.$setSubmitted();
            if (!this.form1_3.$valid) {
              return;
            }
            break;
          default:
            return false;
        }
        if (this.activeTab < 2) {
          this.activeTab++;
          if (1 == this.activeTab) {
            var $element = jQuery("#input_office");
          } else if (2 == this.activeTab) {
            $element = jQuery("#healthInsurance_id");
          }
          $timeout(function () {
            jQuery('body').animate({ scrollTop: jQuery("#tab-1").offset().top - 61 }, '200');
            $element.focus();
          }, 300);

        } else {
          $scope.$emit("nextStep");
        }
      }

      function prevStep() {
        if (this.activeTab > 0) {
          this.activeTab--;
        }
      }
    }],
    controllerAs: "appStep1"
  });

angular
  .module("app")
  .component("appMain", {
    templateUrl: "app/templates/main.html",
    controller: ["$scope", "$rootScope", "appConfig", "$timeout", function ($scope, $rootScope, appConfig, $timeout) {
      var appMain = this;

      this.languages = { "es": "Español", "pt": "Português", "en": "English" };
      this.languageSelectedName = this.languages[appConfig.lang];
      appMain.currentDate = new Date();
      appMain.activeTab = 0;
      var old_tab = appMain.activeTab;
      appMain.nextStep = nextStep;
      $scope.$on("nextStep", function () {
        appMain.nextStep();
      });

      $scope.$watch("appMain.activeTab", function () {

      });

      function nextStep() {

        switch (appMain.activeTab) {
          case 0:
            // validar el primer formulario
            $timeout(function () {
              jQuery('body').animate({ scrollTop: jQuery("#tab-2").offset().top - 61 }, '200');
              jQuery("#input_sickDays").focus();
            }, 300);
            break;
          case 1:
            // validar el segundo formulario
            $rootScope.$broadcast("selectStep3");
            break;
          case 2:

            // validar el segundo formulario
            break;
          default:
            return false;
        }
        if (appMain.activeTab < 2) {
          appMain.activeTab++;
        }
      }
    }],
    controllerAs: "appMain"
  });

angular.module('app')
    .factory("formValueFactory", function () {
        return {
            step1: {
                currency: null,
                currentSalary: null,
                office: null,
                internet: null,
                software: null,
                phone: null,
                newLaptop: null,
                marketing: null,
                insurance: null,
                accountant: null,
                healthInsurance: null,
                taxes: null,
                others: null
            },
            step2: {
                yearlyBillableHours: 2080,
                sickDays: null,
                businessDaysOfVacation: null,
                nonbillableHoursPercentage: null,
                holidays: null
            },
            frelancerCost: function () {
                var vars = [
                    "office",
                    "internet",
                    "software",
                    "phone",
                    "newLaptop",
                    "insurance",
                    "accountant"
                ];
                var sumatory = 0;
                var is_all = true;
                for (var i in vars) {
                    var value = this.step1[vars[i]];
                    if (value != null && angular.isNumber(value) && value >= 0) {
                        sumatory += value;
                    } else {
                        is_all = false;
                    }
                }
                if (is_all) {
                    return sumatory;
                } else {
                    return null;
                }

            },
            getLivingCost: function () {
                var vars = [
                    "healthInsurance",
                    "taxes",
                    "others"
                ];
                var sumatory = 0;
                var is_all = true;
                for (var i in vars) {
                    var value = this.step1[vars[i]];
                    if (value != null && angular.isNumber(value) && value >= 0) {
                        sumatory += value;
                    } else {
                        is_all = false;
                    }
                }
                if (is_all) {
                    return sumatory;
                } else {
                    return null;
                }
            },
            expensesAsFreelancer: function () {
                var freelancerCost = this.frelancerCost();
                var livingCost = this.getLivingCost();
                if (null != freelancerCost && null != livingCost) {
                    return freelancerCost + livingCost;
                }
            },
            getBillableHours: function () {
                var vars = [
                    "sickDays",
                    "businessDaysOfVacation",
                    "holidays"
                ];
                var sumatory = 0;
                var is_all = true;
                for (var i in vars) {
                    var value = this.step2[vars[i]];
                    if (value != null && angular.isNumber(value) && value >= 0) {
                        sumatory += value * 8;
                    } else {
                        is_all = false;
                    }
                }
                if (is_all) {
                    return this.step2.yearlyBillableHours - sumatory;
                } else {
                    return null;
                }
            },
            getBillableYearHoursTotal: function () {
                var billable = this.getBillableHours();
                var nonBillablepercent = this.step2.nonbillableHoursPercentage;
                if (null != billable && angular.isNumber(nonBillablepercent) && nonBillablepercent > 0) {
                    var nonBillablepercentUnit = nonBillablepercent / 100;
                    var nombillabeHours = nonBillablepercentUnit * billable;
                    return billable - Math.ceil(nombillabeHours);
                } else {

                    return null;
                }
            },
            getAdjustedMonthlySalary: function () {
                var monthlyexpensesAsFreelancer = this.expensesAsFreelancer();
                var monthlySalary = this.step1.currentSalary;

                if (null != monthlySalary && null != monthlyexpensesAsFreelancer) {
                    return monthlySalary + monthlyexpensesAsFreelancer;
                }

            }
        };
    });


angular.module("app")
  .directive('formErrors', function () {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        errField: '=',
        errForm: '='
      },
      templateUrl: 'app/templates/form-errors.html'

    };
  });
angular
  .module("app")
  .factory("CurrencyFactory", function () {
    return {
      getAll: function () {
        return [
          { code: "ARS", name: "CURRENCY_ARS", symbol: "AR$" },
          { code: "BRL", name: "CURRENCY_BRL", symbol: "BRL" },
          { code: "CLP", name: "CURRENCY_CLP", symbol: "CLP" },
          { code: "COP", name: "CURRENCY_COP", symbol: "COP" },
          { code: "EUR", name: "CURRENCY_EUR", symbol: "EUR" },
          { code: "MXN", name: "CURRENCY_MXN", symbol: "MXN" },
          { code: "PEN", name: "CURRENCY_PEN", symbol: "PEN" },
          { code: "USD", name: "CURRENCY_USD", symbol: "USD" },
          { code: "UYU", name: "CURRENCY_UYU", symbol: "UYU" }
        ];
      }
    };
  });

angular
    .module("app")
    .factory("CategoryFactory", function () {
        return {
            getAll: function () {
                var amounts_text =
                    "IT & Programación	USD	ARS	Reais	pesos chilenos	pesos colombianos	euros	pesos mexicanos	soles peruanos	pesos uruguayos\n" +
                    "iron - $9	9	133	29	5859	26288	8	163	30	260\n" +
                    "bronze $10.5	10.5	155	34	6835	30670	10	191	35	303\n" +
                    "silver $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "gold $25	25	367	81	16273	73022	23	453	83	720\n" +
                    "platinum $32	32	470	103	20829	93468	29	580	106	922\n" +
                    "hero $38	38	558	122	24735	110994	34	688	126	1095\n" +
                    "									\n" +
                    "Diseño y Multimedia									\n" +
                    "iron - $7	7	103	23	4557	20447	7	127	24	202\n" +
                    "bronze $8	8	118	26	5208	23367	8	145	27	231\n" +
                    "silver $12	12	177	39	7811	35051	11	218	40	346\n" +
                    "gold $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "platinum $30	30	441	97	19527	87627	27	543	100	864\n" +
                    "hero $35	35	514	113	22782	102231	32	634	116	1008\n" +
                    "									\n" +
                    "Traducción y Contenidos									\n" +
                    "iron - $6	6	89	20	3906	17526	6	109	20	173\n" +
                    "bronze $7	7	103	23	4557	20447	7	127	24	202\n" +
                    "silver $9	9	133	29	5859	26288	8	163	30	260\n" +
                    "gold $11	11	162	36	7160	32130	10	200	37	317\n" +
                    "platinum $13	13	191	42	8462	37972	12	236	44	375\n" +
                    "hero $18	18	265	58	11717	52576	16	326	60	519\n" +
                    " 									\n" +
                    "Marketing y Ventas									\n" +
                    "iron - $8	8	118	26	5208	23367	8	145	27	231\n" +
                    "bronze $10	10	147	33	6509	29209	9	181	34	288\n" +
                    "silver $11	11	162	36	7160	32130	10	200	37	317\n" +
                    "gold $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "platinum $22	22	323	71	14320	64260	20	399	73	634\n" +
                    "hero $30	30	441	97	19527	87627	27	543	100	864\n" +
                    "									\n" +
                    "Soporte Administrativo									\n" +
                    "iron - $7	7	103	23	4557	20447	7	127	24	202\n" +
                    "bronze $7	7	103	23	4557	20447	7	127	24	202\n" +
                    "silver $9	9	133	29	5859	26288	8	163	30	260\n" +
                    "gold $12	12	177	39	7811	35051	11	218	40	346\n" +
                    "platinum $14	14	206	45	9113	40893	13	254	47	404\n" +
                    "hero $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "									\n" +
                    "Ingeniería y Manufactura									\n" +
                    "iron - $10	10	147	33	6509	29209	9	181	34	288\n" +
                    "bronze $12	12	177	39	7811	35051	11	218	40	346\n" +
                    "silver $19	19	279	61	12368	55497	17	344	63	548\n" +
                    "gold $22	22	323	71	14320	64260	20	399	73	634\n" +
                    "platinum $28	28	411	90	18226	81785	25	507	93	807\n" +
                    "hero $36	36	529	116	23433	105152	32	652	120	1037\n" +
                    "									\n" +
                    "Finanzas y Administración									\n" +
                    "iron - $9	9	133	29	5859	26288	8	163	30	260\n" +
                    "bronze $10	10	147	33	6509	29209	9	181	34	288\n" +
                    "silver $14	14	206	45	9113	40893	13	254	47	404\n" +
                    "gold $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "platinum $25	25	367	81	16273	73022	23	453	83	720\n" +
                    "hero $30	30	441	97	19527	87627	27	543	100	864\n" +
                    "									\n" +
                    "Legales									\n" +
                    "iron - $15	15	221	49	9764	43814	14	272	50	432\n" +
                    "bronze $17	17	250	55	11066	49655	16	308	57	490\n" +
                    "silver $19	19	279	61	12368	55497	17	344	63	548\n" +
                    "gold $25	25	367	81	16273	73022	23	453	83	720\n" +
                    "platinum $29	29	426	93	18876	84706	26	525	96	836\n" +
                    "hero $33	33	485	106	21480	96389	30	598	110	951";

                var amount_cat_order = ["IT",
                    "D_M",
                    "T_C",
                    "M_S",
                    "A_S",
                    "E_M",
                    "F_A",
                    "L"
                ];
                var amount_currency_order = ["USD", "ARS", "BRL", "CLP", "COP", "EUR", "MXN", "PEN", "UYU"];
                var amount_plan_order = ["iron", "bronze", "silver", "gold", "platinum", "hero"];
                var amount_rows = amounts_text.split("\n");
                var amounts_all = {};

                var cat_index = 0;
                var currency_index = 0;
                var plan_index = 0;

                for (var j in amount_cat_order) {
                    amounts_all[amount_cat_order[j]] = { iron: {}, bronze: {}, silver: {}, gold: {}, platinum: {}, hero: {} };
                }
                for (var i in amount_rows) {
                    if (i == 0) continue;
                    var row = amount_rows[i].split("\t");
                    if (row[1].trim() == "") continue;

                    for (var currency_index in amount_currency_order) {
                        currency_index = parseInt(currency_index);
                        amounts_all[amount_cat_order[cat_index]][amount_plan_order[plan_index]][amount_currency_order[currency_index]] = parseFloat(row[currency_index + 1])
                    }
                    plan_index++;
                    if (plan_index == 6) {
                        plan_index = 0;
                        cat_index++;
                    }
                }
                return [
                    {
                        code: "IT",
                        name: "CAT_IT_AND_PROGRAMMING",
                        amounts: amounts_all["IT"]
                    },
                    {
                        code: "D_M",
                        name: "CAT_DESIGN_AND_MULTIMEDIA",
                        amounts: amounts_all["D_M"]

                    },
                    {
                        code: "T_C",
                        name: "CAT_TRANSLATE_CONTENT",
                        amounts: amounts_all["T_C"]
                    },
                    {
                        code: "M_S",
                        name: "CAT_MARKETING_AND_SALES",
                        amounts: amounts_all["M_S"]
                    },
                    {
                        code: "A_S",
                        name: "CAT_ADMINISTRATION_SUPPORT",
                        amounts: amounts_all["A_S"]
                    },
                    {
                        code: "E_M",
                        name: "CAT_ENGINEERING_AND_MANUFACTURING",
                        amounts: amounts_all["E_M"]
                    },
                    {
                        code: "F_A",
                        name: "CAT_FINANCE_AND_ADMINISTRATION",
                        amounts: amounts_all["F_A"]
                    },
                    {
                        code: "L",
                        name: "CAT_LEGAL",
                        amounts: amounts_all["L"]
                    }
                ];
            }
        };
    });


/**
 * Traducción y Contenidos
Marketing y Ventas
Soporte Administrativo
Ingeniería y Manufactura
Finanzas y Administración
Legales
 */
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/techs/tech.html","<div class=\"tech\">\n  <img class=\"tech-logo\" ng-src=\"{{ $ctrl.tech.logo }}\">\n  <h3 class=\"tech-h3\">\n    {{ $ctrl.tech.title }}\n  </h3>\n  <p>{{ $ctrl.tech.text1 }}</p>\n  <p>{{ $ctrl.tech.text2 }}</p>\n</div>\n");
$templateCache.put("app/techs/techs.html","<div class=\"techs-container\">\n  <h2 class=\"techs-h2\">\n    Cooked with all these awesome technologies:\n  </h2>\n  <div class=\"techs\">\n    <fountain-tech ng-repeat=\"tech in $ctrl.techs\" tech=\"tech\"></fountain-tech>\n  </div>\n</div>\n");
$templateCache.put("app/templates/footer.html","<footer>\r\n    <div class=\"credits text-center\">\r\n        <a rel=\"author\" href=\"https://www.workana.com/freelancer/aldana-fiandrino?utm_source=calculadora&utm_medium=footer&utm_campaign=SideP\">\r\n            <i class=\"glyphicon glyphicon-pencil icon\"></i><span>{{ \"DESIGNE_BY\" | translate }}</span>\r\n            <h4 class=\"author-name\">Aldana Fiandrino</h4>\r\n        </a>\r\n        <a rel=\"author\" href=\"https://www.workana.com/freelancer/argenis-fontalvo?utm_source=calculadora&utm_medium=footer&utm_campaign=SideP\">\r\n            <i class=\"glyphicon customicon customicon-code icon\"></i><span>{{  \"DEVELOPED_BY\" | translate }}</span>\r\n            <h4 class=\"author-name\">Argenis Fontalvo</h4>\r\n        </a>\r\n    </div>\r\n    <div class=\"text-center centered\">\r\n        <a href=\"http://www.hechoenamericalatina.org/\" target=\"_blank\" class=\"made-in\">Hecho en América latina</a>\r\n    </div>\r\n    <!--<div class=\"copy\"><p>© 2012-{{ appMain.currentDate | date:\'yyyy\' }} Workana LLC - Todos los derechos reservados</p></div>-->\r\n</footer>");
$templateCache.put("app/templates/form-errors.html","<ul class=\"angular-error-list\">\r\n    <li ng-show=\"(errField.$error.required && errField.$touched) || (errField.$error.required && errForm.$submitted)\">\r\n        <div>\r\n            Este campo es requerido\r\n        </div>\r\n    </li>\r\n    <li ng-show=\"(errField.$error.maxlength && errField.$touched) || (errField.$error.maxlength && errForm.$submitted)\">\r\n        <div>\r\n            El texto es muy largo\r\n        </div>\r\n    </li>\r\n    <li ng-show=\"!errField.$error.required && ( (errField.$error.uiDateValidator && errField.$touched) || (errField.$error.uiDateValidator && errForm.$submitted) )\">\r\n        <div>\r\n            El formato de fecha no es válido (DD/MM/YYYY)\r\n        </div>\r\n    </li>\r\n    <li ng-show=\"!errField.$error.required && ( (errField.$error.email && errField.$touched) || (errField.$error.email && errForm.$submitted) )\">\r\n        <div>\r\n            El formato de email es invalido\r\n        </div>\r\n    </li>\r\n    <li ng-show=\"!errField.$error.required && ( (errField.$error.pattern && errField.$touched) || (errField.$error.pattern && errForm.$submitted) )\">\r\n        <div>\r\n            Formato inválido\r\n        </div>\r\n    </li>\r\n    <li ng-show=\"!errField.$error.required && ( (errField.$error.number && errField.$touched) || (errField.$error.number && errForm.$submitted) )\">\r\n        <div>\r\n            El valor debe ser numérico\r\n        </div>\r\n    </li>\r\n</ul>");
$templateCache.put("app/templates/header.html","<header>\r\n    <nav class=\"navbar navbar-default\">\r\n        <div class=\"container container-workana\">\r\n            <div class=\"navbar-header\">\r\n                <a class=\"navbar-brand\" href=\"/\" id=\"logo\"><img alt=\"CalculadoraFreela\" src=\"app/assets/images/logo-calculadora-freela.png\"></a>\r\n                <!--<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\r\n                    <span class=\"sr-only\">Toggle navigation</span>\r\n                    <span class=\"icon-bar\"></span>\r\n                    <span class=\"icon-bar\"></span>\r\n                    <span class=\"icon-bar\"></span>\r\n                </button>-->\r\n                <div class=\"navbar-text navbar-right\">\r\n                    <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\r\n                        <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle>\r\n                          {{ appMain.languageSelectedName }} <span class=\"caret\"></span>\r\n                        </button>\r\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\r\n                          <li role=\"menuitem\" ng-repeat=\"(lang_code, lang_name ) in appMain.languages\"><a rel=\"alternate\" hreflang=\"es\" ng-href=\"/{{ lang_code }}/\">{{ lang_name }}</a></li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            \r\n            \r\n        </div>\r\n    </nav>\r\n    <div class=\"header-image\">\r\n    <div class=\"container container-workana\">\r\n        <div class=\"col-xs-12 col-md-6 col-md-offset-3 text-center\">\r\n            <p id=\"logo-header\"><img class=\"img-responsive\" src=\"app/assets/images/logo-header.png\"></p>\r\n            <h1 class=\"text-center main-title\">\r\n                {{ \"HIGHLIGHTED_TEXT\" | translate }}\r\n            </h1>\r\n        </div>\r\n    </div>\r\n    </div>\r\n</header>\r\n");
$templateCache.put("app/templates/main.html","<ng-include src=\"\'app/templates/header.html\'\"></ng-include>\r\n<div class=\"container container-workana\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <p class=\"text-center\"><a href=\"https://workana.com/?utm_source=calculadora&utm_medium=hechoxbadge&utm_campaign=SideP\" target=\"_blank\" class=\"made-in-workana\">{{ \"MADE_IN_WORKANA\" | translate }}</a></p></div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <uib-tabset active=\"appMain.activeTab\" template-url=\"app/templates/tab-wizard.html\">\r\n                <uib-tab index=\"0\" heading=\"Static title\"><uib-tab-heading>01. <span class=\"description\"> {{ \'TAB_STEP1\' | translate }}</span></uib-tab-heading><app-step1></app-step1></uib-tab>\r\n                <uib-tab index=\"1\" disable=\"appMain.activeTab<1\"><uib-tab-heading>02. <span class=\"description\">{{ \'TAB_STEP2\' | translate }}</span></uib-tab-heading><app-step2></app-step2></uib-tab>\r\n                <uib-tab index=\"2\" disable=\"appMain.activeTab<2\" select=\"alert(\'hola\');\"><uib-tab-heading>03. <span class=\"description\">{{ \'TAB_STEP3\' | translate }}</span></uib-tab-heading><app-step3></app-step3></uib-tab>\r\n            </uib-tabset>\r\n        </div>\r\n    </div>\r\n</div>\r\n<ng-include src=\"\'app/templates/footer.html\'\"></ng-include>\r\n");
$templateCache.put("app/templates/step1-1.html","<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <!--form de la primera pestaña -->\r\n        <form name=\"appStep1.form1_1\" id=\"form1_1\" class=\"tab-form\">\r\n            <div class=\"form-group\">\r\n                <label>{{ \'CURRENCY\' | translate }}</label>\r\n                <div>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-xs-12 col-md-5\">\r\n                            <div class=\"dropdown-custom\">\r\n                            <button class=\"btn btn-primary btn-block\" style=\"position: relative\"> {{ appStep1.values.currency.name | translate}} <span style=\"float: right\">| &dtrif;</span></button>\r\n                            <select name=\"currency\" class=\"form-control col-md-5\" ng-options=\"item as item.name | translate for item in appStep1.currencies track by item.code\" ng-model=\"appStep1.values.currency\" required=\"required\" style=\"position: absolute;  top: 0; opacity: 0\">\r\n                            </select>\r\n                            </div>\r\n                            <form-errors err-field=\"appStep1.form1_1.currency\" err-form=\"appStep1.form1_1\"></form-errors>\r\n                            \r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n\r\n                <label for=\"current_salary\">\r\n                    {{ \'CURRENT_SALARY\' | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'CURRENT_SALARY_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\'></a>\r\n                    <small style=\"display: block\">{{ \'CURRENT_SALARY_HELP\' | translate }}</small>\r\n                </label>\r\n                <div class=\"row\">\r\n                    <div class=\"col-sm-5 clearfix\">\r\n                        <input class=\"form-control\" id=\"salario_actual\" type=\"number\" placeholder=\"{{ appStep1.values.currency.symbol }}\" ng-model=\"appStep1.values.currentSalary\" name=\"currentSalary\" required=\"required\">\r\n                        <form-errors err-field=\"appStep1.form1_1.currentSalary\" err-form=\"appStep1.form1_1\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/templates/step1-2.html","<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <form name=\"appStep1.form1_2\" id=\"form1_2\" class=\"tab-form\">\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-12\">\r\n                    <h3 class=\"section-subtitle\">{{ \"STEP1-2_SUBTILE\"| translate }}</h3>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_office\">{{ \"OFFICE\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'OFFICE_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-placement=\"auto top-left\" popover-append-to-body=\"true\"></a></label>\r\n                        <input name=\"office\" required=\"required\" ng-model=\"appStep1.values.office\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" id=\"input_office\">\r\n                        <form-errors err-field=\"appStep1.form1_2.office\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_internet\">{{ \"INTERNET\" | translate }}</label>\r\n                        <input name=\"internet\" required=\"required\" ng-model=\"appStep1.values.internet\" placeholder=\"{{ appStep1.values.currency.symbol }}\" type=\"number\" class=\"form-control\" id=\"input_internet\" popover-placement=\"auto top-left\" popover-append-to-body=\"true\">\r\n                        <form-errors err-field=\"appStep1.form1_2.internet\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_software\">{{ \"SOFTWARE\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'SOFTWARE_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-placement=\"auto top-left\" popover-append-to-body=\"true\"></a></label>\r\n                        <input ng-model=\"appStep1.values.software\" type=\"number\" class=\"form-control\" placeholder=\"{{ appStep1.values.currency.symbol}}\" name=\"software\" required=\"required\" id=\"input_software\">\r\n                        <form-errors err-field=\"appStep1.form1_2.software\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_phone\">{{ \"PHONE\" | translate }}</label>\r\n                        <input ng-model=\"appStep1.values.phone\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" name=\"phone\" required=\"required\" id=\"input_phone\">\r\n                        <form-errors err-field=\"appStep1.form1_2.phone\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_newLaptop\">{{ \"NEW_LAPTOP_EVERY_TWO_YEARS\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'NEW_LAPTOP_EVERY_TWO_YEARS_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></label>\r\n                        <input ng-model=\"appStep1.values.newLaptop\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" name=\"newLaptop\" required=\"required\" id=\"input_newLaptop\">\r\n                        <form-errors err-field=\"appStep1.form1_2.newLaptop\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_marketing\">{{ \"MARKETING\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'MARKETING_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\" popover-placement=\"auto top-left\"></a></label>\r\n                        <input ng-model=\"appStep1.values.marketing\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" name=\"marketing\" required=\"required\" id=\"input_marketing\">\r\n                        <form-errors err-field=\"appStep1.form1_2.marketing\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                \r\n            </div>\r\n            \r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_insurance\">{{ \"INSURANCE_BAD_WEATHER\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'HELP_INSURANCE_BAD_WEATHER\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></label>\r\n                        <input name=\"insurance\" ng-model=\"appStep1.values.insurance\" required=\"required\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" id=\"input_insurance\">\r\n                        <form-errors err-field=\"appStep1.form1_2.insurance\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_accountant\">{{ \"ACCOUNTANT\" | translate }}</label>\r\n                        <input ng-model=\"appStep1.values.accountant\" placeholder=\"{{ appStep1.values.currency.symbol}}\" type=\"number\" class=\"form-control\" name=\"accountant\" required=\"required\" id=\"input_accountant\">\r\n                        <form-errors err-field=\"appStep1.form1_2.accountant\" err-form=\"appStep1.form1_2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                \r\n            </div>\r\n            \r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("app/templates/step1-3.html","<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <form name=\"appStep1.form1_3\" class=\"tab-form\">\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-12\">\r\n                    <h3 class=\"section-subtitle\">{{ \"STEP1-3_SUBTILE\"| translate }}</h3>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"\">{{ \"HEALTH_INSURANCE\" | translate }}</label>\r\n                        <input ng-model=\"appStep1.values.healthInsurance\" placeholder=\"{{ appStep1.values.currency.symbol }}\" type=\"number\" class=\"form-control\" name=\"healthInsurance\" id=\"healthInsurance_id\" required=\"required\">\r\n                        <form-errors err-field=\"appStep1.form1_3.healthInsurance\" err-form=\"appStep1.form1_3\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"\">{{ \"TAXES\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'TAXES_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\" popover-placement=\"auto top-left\"></a></label>\r\n                        <input ng-model=\"appStep1.values.taxes\" placeholder=\"{{ appStep1.values.currency.symbol }}\" type=\"number\" class=\"form-control\" name=\"taxes\" required=\"required\">\r\n                        <form-errors err-field=\"appStep1.form1_3.taxes\" err-form=\"appStep1.form1_3\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"\">{{ \"OTHERS\" | translate }}</label>\r\n                        <input ng-model=\"appStep1.values.others\" placeholder=\"{{ appStep1.values.currency.symbol }}\" type=\"number\" class=\"form-control\" name=\"others\" required=\"required\">\r\n                        <form-errors err-field=\"appStep1.form1_3.others\" err-form=\"appStep1.form1_3\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("app/templates/step1.html","<div class=\"row\" id=\"tab-1\">\r\n    <div class=\"col-sm-7\">\r\n    <uib-tabset active=\"appStep1.activeTab\" class=\"step1subtabs\">\r\n        <uib-tab index=\"0\" heading=\"01\"><ng-include src=\"\'app/templates/step1-1.html\'\"></ng-include></uib-tab>\r\n        <uib-tab index=\"1\" heading=\"02\"><ng-include src=\"\'app/templates/step1-2.html\'\"></ng-include></uib-tab>\r\n        <uib-tab index=\"2\" heading=\"03\"><ng-include src=\"\'app/templates/step1-3.html\'\"></ng-include></uib-tab>\r\n    </uib-tabset>\r\n    </div>\r\n    <div class=\"col-sm-5 hidden-xs\">\r\n        <div class=\"text-center line-with-icon\"><hr><i class=\"icon glyphicon customicon customicon-money\"></i></div>\r\n        <p class=\"tab-description\" ng-bind-html=\"\'STEP1_TEXT\' | translate\"></p>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <p class=\"text-center\">\r\n        <button type=\"button\" class=\"btn btn-circle btn-default\" ng-click=\"appStep1.prevStep()\" ng-class=\"{disabled: appStep1.activeTab<1}\" ng-hide=\"appStep1.activeTab==0\"><span class=\"glyphicon glyphicon-chevron-left\"></span></button>\r\n        <button type=\"button\" class=\"btn btn-primary btn-circle\" ng-click=\"appStep1.nextStep()\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\': appStep1.activeTab<2, \'glyphicon-ok\': appStep1.activeTab==2 }\"></span></button>\r\n    </p>\r\n</div>\r\n");
$templateCache.put("app/templates/step2.html","<div class=\"row\" id=\"tab-2\">\r\n    <div class=\"col-sm-7\">\r\n        <form name=\"appStep2.form2\" class=\"tab-form\">\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_yearlyBillableHours\">{{ \"YEARLY_BILLABLE_HOURS\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'YEARLY_BILLABLE_HOURS_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></label>\r\n                        <input ng-model=\"appStep2.values.yearlyBillableHours\" type=\"number\" ng-disabled=\"true\" class=\"form-control\" name=\"yearlyBillableHours\" id=\"input_yearlyBillableHours\">\r\n                        <form-errors err-field=\"appStep2.form2.yearlyBillableHours\" err-form=\"appStep2.form2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_sickDays\">{{ \"SICK_DAYS\" | translate }} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'SICK_DAYS_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></label>\r\n                        <input ng-model=\"appStep2.values.sickDays\" type=\"number\" class=\"form-control\" name=\"sickDays\" id=\"input_sickDays\" required=\"required\">\r\n                        <form-errors err-field=\"appStep2.form2.sickDays\" err-form=\"appStep2.form2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_businessDaysOfVacation\">{{ \"BUSINESS_DAYS_OF_VACATION\" | translate }}</label>\r\n                        <input ng-model=\"appStep2.values.businessDaysOfVacation\" type=\"number\" class=\"form-control\" name=\"businessDaysOfVacation\" id=\"input_businessDaysOfVacation\" required=\"required\">\r\n                        <form-errors err-field=\"appStep2.form2.businessDaysOfVacation\" err-form=\"appStep2.form2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_nonbillableHoursPercentage\">{{ \"NONBILLABLE_HOURS_PERCENTAGE\" | translate }}  <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'NONBILLABLE_HOURS_PERCENTAGE_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></label>\r\n                        <input ng-model=\"appStep2.values.nonbillableHoursPercentage\" type=\"number\" class=\"form-control\" placeholder=\"%\" name=\"nonbillableHoursPercentage\" id=\"input_nonbillableHoursPercentage\" required=\"required\">\r\n                        <form-errors err-field=\"appStep2.form2.nonbillableHoursPercentage\" err-form=\"appStep2.form2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-6\">\r\n                    <div class=\"form-group\">\r\n                        <label for=\"input_holidays\">{{ \"HOLIDAYS\" | translate }}</label>\r\n                        <input ng-model=\"appStep2.values.holidays\" type=\"number\" class=\"form-control\" name=\"holidays\" id=\"input_holidays\" required=\"required\">\r\n                        <form-errors err-field=\"appStep2.form2.holidays\" err-form=\"appStep2.form2\"></form-errors>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n    <div class=\"col-sm-5 hidden-xs\" style=\"\">\r\n        <div class=\"text-center line-with-icon\"><hr><i class=\"icon glyphicon glyphicon-time\"></i></div>\r\n        <p class=\"tab-description\" ng-bind-html=\"\'STEP2_TEXT\' | translate\"></p>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <p class=\"text-center\">\r\n        <button type=\"button\" class=\"btn btn-circle btn-default\" ng-click=\"appStep2.prevStep()\"><span class=\"glyphicon glyphicon-chevron-left\"></span></button>\r\n        <button type=\"button\" class=\"btn btn-primary btn-circle\" ng-click=\"appStep2.nextStep()\"><span class=\"glyphicon glyphicon-ok\"></span></button>\r\n    </p>\r\n</div>\r\n");
$templateCache.put("app/templates/step3.html","<div class=\"row\">\r\n    <div class=\"col-sm-5 col-xs-12\">\r\n        <table class=\"table\">\r\n            <tbody>\r\n                <tr>\r\n                    <td><i class=\"glyphicon customicon customicon-money\"></i></td>\r\n                    <td>{{ \"MONTHLY_SALARY_ADJUSTED\" | translate }}</td>\r\n                    <td>{{ appStep3.values.step1.currency.symbol }} {{ appStep3.getAdjustedMonthlySalary() }}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td><i class=\"glyphicon customicon customicon-time\"></i></td>\r\n                    <td>{{ \"MONTLY_BILLABLE_HOURS\" | translate}} <a class=\"glyphicon glyphicon-question-sign icon-help\" uib-popover=\"{{ \'MONTLY_BILLABLE_HOURS_TOOLTIP\' | translate }}\" popover-trigger=\'\"mouseenter\"\' popover-append-to-body=\"true\"></a></td>\r\n                    <td>{{ appStep3.getMonthlyBillableHoursTotal() }}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td colspan=\"3\">\r\n                        <strong class=\"clearfix\">Total por hora</strong>\r\n                        <div class=\"text-center w-total text-nowrap\"><span>{{ appStep3.values.step1.currency.symbol }}</span> <span>{{ appStep3.totalperHour() }}</span></div>\r\n                        \r\n                    </td>\r\n                </tr>\r\n                <tr>\r\n                    <td colspan=\"3\">\r\n                            <ul class=\"list-inline\" style=\"text-align: center\">\r\n                                <li><a href=\"{{ appStep3.mailto_url }}\"><i class=\"glyphicon customicon customicon-email\"></i></a></li>\r\n                                <li><a href=\"\" ng-click=\"appStep3.sharePopup(\'facebook\')\"><i class=\"glyphicon customicon customicon-facebook\"></i></a></li>\r\n                                <li><a href=\"\" ng-click=\"appStep3.sharePopup(\'twitter\')\"><i class=\"glyphicon customicon customicon-twitter\"></i></a></li>\r\n                            </ul>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <p class=\"text-center\">\r\n            <a class=\"btn btn-default btn-calltoaction\" href=\"https://www.workana.com/jobs?utm_source=calculadora&utm_medium=cta&utm_campaign=SideP\">{{ \"SEE_OFFERS_WORKANA\" | translate }}</a>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-sm-5 col-sm-offset-2 col-xs-12\">\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-11\">\r\n                <p class=\"tab-description\" style=\"position: relative; clear: both\" ng-bind-html=\"\'STEP3_TEXT\' | translate\"></p>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-group\">\r\n                    <div style=\"position: relative\" class=\"dropdown-custom\">\r\n                        <button class=\"btn btn-primary btn-block\" style=\"position: relative\"> {{ appStep3.values.category.name | translate}} <span style=\"float: right\">| &dtrif;</span></button>\r\n                        <select class=\"form-control col-md-5\" ng-options=\"item as item.name | translate for item in appStep3.categories track by item.code\" ng-model=\"appStep3.values.category\" ng-selected=\"appStep3.buildPercentages()\">\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <table class=\"table w-table\">\r\n                    <tbody>\r\n                        <tr>\r\n                            <td class=\"w-type-name\">{{ \"YOU\" | translate }}</td>\r\n                            <td class=\"w-type-icon\"><i class=\"glyphicon customicon customicon-user\"></i></td>\r\n                            <td class=\"w-type-progress\" width=\"50%\"><div class=\"progressbar-arrow blue\" style=\"width: {{ appStep3.percentage_by_category }}%\"><span class=\"progressbar-content\"></span></div></td>\r\n                            <td class=\"w-type-amount\" style=\"text-align: left\"><i class=\"glyphicon customicon customicon-money customicon-money-mini\" style=\"vertical-align: middle\"></i> <span style=\"vertical-align: middle\"> {{ appStep3.totalperHour() }}</span></td>\r\n                        </tr>\r\n                        <tr ng-repeat=\"item in [\'hero\',\'platinum\',\'gold\',\'silver\',\'bronze\',\'iron\']\">\r\n                            <td class=\"w-type-name\">{{ (\"GAMIFICATION_\" + item) | translate }}</td>\r\n                            <td class=\"w-type-icon\"><i class=\"glyphicon customicon customicon-{{ item }}\"></i></td>\r\n                            <td class=\"w-type-progress\" width=\"50%\"><div class=\"progressbar-arrow red\" style=\"width: {{ appStep3.values.category.percentages[item] }}%\" ng-class=\'{\"min-50\": appStep3.values.category.percentages[item]<= 50, \"more-50\": appStep3.values.category.percentages[item]> 50 }\'><span class=\"progressbar-content\"></span></div></td>\r\n                            <td class=\"w-type-amount\" style=\"text-align: left\"><i class=\"glyphicon customicon customicon-money customicon-money-mini\" style=\"vertical-align: middle\"></i> <span style=\"vertical-align: middle\">{{ appStep3.values.category.amounts[item][appStep3.values.step1.currency.code]}}</span></td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/templates/step3Modal.html","<div class=\"modal-body\">\r\n    <div class=\"text-center\" style=\"padding: 30px 0 5px 0\"><img src=\"app/assets/images/hand-up-workana2.png\"></div>\r\n    <div class=\"text-center\">\r\n    <h2> {{ \"FINAL_MODAL_TITLE\" | translate }}</h2>\r\n    <p>{{ \"FINAL_MODAL_TEXT\" | translate }}</p>\r\n    <p style=\"padding: 20px\"><a class=\"btn btn-default\" href=\"https://www.workana.com/jobs?utm_source=calculadora&utm_medium=cta&utm_campaign=SideP\">{{ \"SEE_OFFERS\" | translate }}</a></p>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/templates/step3ModalWindow.html","\r\n<button style=\"position: fixed; top: 0; right: 0\" class=\"btn btn-default\" ng-click=\"cancel()\"><span class=\"glyphicon glyphicon-remove\"></span></button> \r\n<div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\">\r\n    {{ appStep3 }}\r\n    <div class=\"modal-content\" uib-modal-transclude></div>\r\n</div>");
$templateCache.put("app/templates/tab-wizard.html","<div>\r\n    <ul class=\"nav nav-{{tabset.type || \'tabs\'}} nav-wizard hidden-xs\" ng-class=\"{\'nav-stacked\': vertical, \'nav-justified\': justified}\" ng-transclude></ul>\r\n    <div class=\"tab-content panel panel-tab\">\r\n      <!--<div class=\"tab-pane\"\r\n           ng-repeat=\"tab in tabset.tabs\"\r\n           ng-class=\"{active: tabset.active === tab.index}\"\r\n           uib-tab-content-transclude=\"tab\">\r\n      </div>-->\r\n      \r\n        <div ng-repeat-start=\"tab in tabset.tabs\" class=\"panel-heading visible-xs-block\" ng-class=\"{\'active\': tabset.active === tab.index}\">\r\n            <a ng-click=\"tabset.active=tab.index\" ng-if=\"tab.index==0\">01. <span class=\"description\"> {{ \'TAB_STEP1\' | translate }}</span></a>\r\n            <a ng-click=\"tabset.active=tab.index\" ng-if=\"tab.index==1\">02. <span class=\"description\"> {{ \'TAB_STEP2\' | translate }}</span></a>\r\n            <a ng-click=\"tabset.active=tab.index\" ng-if=\"tab.index==2\">03. <span class=\"description\"> {{ \'TAB_STEP3\' | translate }}</span></a>\r\n        </div>\r\n        <div class=\"tab-pane panel-body\" ng-repeat-end ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\">\r\n        </div>\r\n    </div>\r\n</div>");}]);
/*angular
  .module('app')
  .config(routesConfig);
**/
/** @ngInject */
/**function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('app', {
      url: '/',
      template: '<app-main></app-main>'
    });
  $stateProvider
    .state('app-es', {
      url: '/es/',
      template: '<app-main></app-main>'
    });
  $stateProvider
    .state('app-pt', {
      url: '/pt/',
      template: '<app-main></app-main>'
    });
}
*/